var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticStyle:{"position":"absolute","left":"-9999px","width":"1px","height":"1px"},attrs:{"type":"submit","tabindex":"-1","aria-hidden":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }